import { memo, useCallback, useMemo } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Icon } from '@cbhq/cds-web/icons/Icon';

import { useClientProps } from '../providers/ClientPropsProvider';

import { TogglerActionItem } from './TogglerActionItem';

const messages = defineMessages({
  dark: {
    defaultMessage: 'Dark mode',
    id: 'DarkModeAction.dark',
    description: 'Label for the dark mode action item in the profile menu',
  },
});

export const DarkModeActionItem = memo(() => {
  const { onThemeToggle, themeToggleValue } = useClientProps();
  const { formatMessage } = useIntl();

  if (!onThemeToggle || !themeToggleValue) {
    throw new Error('Missing required props for theme toggle');
  }

  const onMenuItemPress = useCallback(() => {
    if (!onThemeToggle) return;
    // if is dark mode, set to light mode, else set to dark mode
    onThemeToggle(themeToggleValue === 'dark' ? 'light' : 'dark');
  }, [onThemeToggle, themeToggleValue]);

  const icon = useMemo(() => {
    return <Icon name="moon" color="fg" />;
  }, []);

  return (
    <TogglerActionItem
      callback={onMenuItemPress}
      icon={icon}
      label={formatMessage(messages.dark)}
      toggleValue={themeToggleValue === 'dark'}
    />
  );
});
